import useAuth from '@/hooks/useAuth';
import { useSearchParams } from '@/hooks/useSearchParams';
import { useUpdateUserMutation } from '@/queries/user.queries';
import timezoneService from '@/services/timezone.service';
import ITimeZone from '@/types/ITimeZone';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

export default function useNotificationBar() {
	const { t } = useTranslation();
	const updateUserMutation = useUpdateUserMutation();
	const { impersonatedUser, impersonate, getCurrentUser } = useAuth();
	const params = useSearchParams();
	const history = useHistory();

	return {
		t,
		changeTimeZone: (timeZone: ITimeZone) => updateUserMutation.mutateAsync({ timeZone }),
		handleStopImpersonatingClick: () => impersonate(undefined),
		handleCloseTimeZoneModalClick: () => history.replace(history.location.pathname),
		handleOpenTimeZoneModalClick: () => history.replace(`${history.location.pathname}?viewTzModal=true`),
		currentTimeZone: timezoneService.getTimeZone(),
		hasDifferentTimezone: getCurrentUser().timeZone !== timezoneService.getTimeZone(),
		hasNotifications: impersonatedUser || getCurrentUser().timeZone !== timezoneService.getTimeZone(),
		impersonatedUser,
		isTimeZoneModalVisible: params.get('viewTzModal') === 'true',
		profileTimeZone: getCurrentUser().timeZone,
	};
}
